import React, { useEffect } from "react";
import { useBroadcastEditContext } from "./BroadcastEditContainer";
import { Alert, Button, Select, TextInput } from "@opendate-app/setlist";
import BroadcastSidebar, { StepFooter } from "./BroadcastSidebar";

var _ = require('lodash');

const debouncedUpdateBroadcast = _.debounce((updateBroadcast, payload) => {
  updateBroadcast(payload);
}, 500);

const styles = {
  alert: {
    marginBottom: 24,
  },
  heading: {
    color: "var(--sl-text-primary)",
    fontSize: 20,
    fontWeight: 600,
    marginBottom: 4,
  },
  description: {
    color: "var(--sl-text-tertiary)",
    marginBottom: 24,
  },
  fields: {
    display: "flex",
    flexDirection: "column",
    gap: 24,
    maxWidth: 352,
  },
};

const FromTab = () => {
  const {
    team,
    venueOwnership,
    setTab,
    updateBroadcast,
    beefreeTemplate,
    sendDomain,
    availableSendDomains,
    emailSendDomain,
    setEmailSendDomain,
    selectedSendDomain,
    setSelectedSendDomain,
  } = useBroadcastEditContext();

  const sendDomainOptions = !selectedSendDomain || availableSendDomains.some(domain => domain.id === selectedSendDomain.id)
    ? availableSendDomains
    : [selectedSendDomain, ...availableSendDomains];

  const updateEmailSendDomain = (attributes) => {
    setEmailSendDomain({
      ...emailSendDomain,
      ...attributes
    });

    debouncedUpdateBroadcast(updateBroadcast, {
      beefree_template_attributes: {
        ...beefreeTemplate,
        email_send_domain_attributes: {
          ...emailSendDomain,
          ...attributes
        }
      }
    });
  };

  return (
    <BroadcastSidebar>
      {availableSendDomains.length === 0 ? (
        <div style={styles.alert}>
          <Alert
            color="error"
            role="alert"
            title="Your sending domain has not been setup yet."
            actions={
              <Button as="a" variant="link-color" href={`/teams/${team.id}/marketing_settings?venue_ownership_id=${venueOwnership.id}&tab=email`}>
                Get started
              </Button>
            }
          />
        </div>
      ) : null}
      <h3 style={styles.heading}>From</h3>
      <p style={styles.description}>Who is sending this email?</p>
      <div style={styles.fields}>
        <TextInput
          label="Name"
          required
          helpText="We recommend using a name that your subscribers will recognize. Like your venue name."
          disabled={!emailSendDomain}
          id="fromName"
          value={emailSendDomain?.name || ""}
          onChange={(e) => updateEmailSendDomain({ name: e.target.value })}
        />
        <Select
          label="Email Address"
          required
          disabled={!emailSendDomain && availableSendDomains.length === 0}
          options={sendDomainOptions.map(domain => ({ value: domain.id, label: domain.full_from_address }))}
          value={selectedSendDomain?.id}
          onChange={id => {
            const option = sendDomainOptions.find(domain => domain.id === id);
            setSelectedSendDomain(option);
            updateEmailSendDomain({ send_domain_id: option.id, name: option.name });
          }}
        />
      </div>
      <StepFooter onBack={() => setTab("recipients")} onNext={() => setTab("content-select")} />
    </BroadcastSidebar>
  );
};

export default FromTab;
